"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function SparkleEmptyBlockSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 89, height: 56, viewBox: "0 0 89 56", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "Sparkle-empty-block", clipPath: "url(#clip0_213_2152)" },
            react_1.default.createElement("g", { id: "Group 1000002855" },
                react_1.default.createElement("path", { id: "Vector", d: "M85.9392 11.6958C82.5397 15.1657 72.9009 19.3233 67.413 13.9469", stroke: "black", strokeWidth: 5.13, strokeLinejoin: "round" }),
                react_1.default.createElement("path", { id: "Vector_2", d: "M85.9392 11.7518C82.5207 15.203 78.5084 24.9031 83.9667 30.3097", stroke: "black", strokeWidth: 5.13, strokeLinejoin: "round" }),
                react_1.default.createElement("path", { id: "Vector 819", d: "M1.29577 33.6192C36.5791 43.7779 61.1714 36.8267 79.5652 18.0791", stroke: "#FFD552", strokeWidth: 5.13216 }),
                react_1.default.createElement("path", { id: "Vector 819_2", d: "M79.5651 18.0792C65.9276 31.979 48.8828 39.3943 26.5998 38.1596", stroke: "#659675", strokeWidth: 5.13216 }),
                react_1.default.createElement("path", { id: "Vector 819_3", d: "M79.5651 18.08C72.9879 24.7838 65.618 29.9793 57.2502 33.4234", stroke: "black", strokeWidth: 5.13216 }))),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_213_2152" },
                react_1.default.createElement("rect", { width: 88, height: 56, fill: "white", transform: "translate(0.5)" }))));
}
function SparkleEmptyBlock(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(SparkleEmptyBlockSvg, Object.assign({}, svgProps)));
}
exports.default = SparkleEmptyBlock;
//# sourceMappingURL=SparkleEmptyBlock.js.map